let _setLoading = null;

export const loaderInstance = {
  set: (state) => {
    if (_setLoading) _setLoading(state);
  },
  attach: (setLoadingFn) => {
    _setLoading = setLoadingFn;
  }
};
